import OrgGuardStore from "features/main/main-router/org-guard/OrgGuardStore"
import RouterStore from "features/main/main-router/org-guard/RouterStore"
import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { AccessDeniedDefault, AccessDeniedType, ContentAccessDenied, DocumentNoLongerAvailable } from "./AccessDenied"
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined"
import LockOutlined from "@mui/icons-material/LockOutlined"

interface AccessDeniedStoreProps {
   orgGuardStore: OrgGuardStore | undefined
   routerStore: RouterStore | undefined
   type: AccessDeniedType
}

export default class AccessDeniedStore {
   sp

   constructor(sp: AccessDeniedStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get org() {
      return this.sp.orgGuardStore?.org
   }

   get orgName() {
      return this.org?.name || 'your org'
   }

   get isClient() {
      return this.org?.orgType === 'client'
   }

   get Icon() {
      if (this.sp.type === 'document-no-longer-available') {
         return InsertDriveFileOutlined
      } else {
         return LockOutlined
      }
   }

   get content() {
      switch (this.sp.type) {
         case 'default':
             return AccessDeniedDefault
         case 'content-access-denied':
            return ContentAccessDenied 
         case 'document-no-longer-available':
            return DocumentNoLongerAvailable
      }
   }

   get canGoHome() {
      return !this.sp.orgGuardStore?.sp.authStore.isGuest && this.sp.routerStore
   }

   goToSupport = () => {
      window.open('https://www.thegaphq.com/contact-us', "_blank")
   }

   goHome = () => {
      this.sp.routerStore?.navigateToOrgsDefault()
   }
}

export const { Provider: AccessDeniedStoreProvider, useProvidedStore: useAccessDeniedStore } = createStoreContext(AccessDeniedStore)
